// extracted by mini-css-extract-plugin
export default {"fs9":"StarRating_fs9__H+hwq"};